/* eslint-disable react/no-children-prop */
import 'font-awesome/css/font-awesome.min.css';
import { lazy, Suspense } from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import './App.css';

import About from './pages/PageAbout';
import Confirmation from './pages/PageConfirmation';
import Faq from './pages/PageFaq';
import FavoriteVenues from './pages/PageFavoriteVenues';
import Home from './pages/PageHome';
import HostedVenues from './pages/PageHostedVenues';
import HowItWorks from './pages/PageHowItWorks';
import HostReservations from './pages/PageHostReservations';
import HostStripeRedirect from './pages/PageHostStripeRedirect';
import Legal from './pages/PageLegal';
import { PageListYourVenue, PageNotAFit } from './pages/PageListYourVenue';
import Logout from './pages/PageLogout';
import Profile from './pages/PageProfile';
import ReservedVenues from './pages/PageReservedVenues';
import SearchVenues from './pages/PageSearchVenues';
// import HostVenue from './pages/PageHostVenues.jsx'
// import StripeRefresh from './pages/PageStripeRefresh.jsx'
import { ToastContainer } from 'react-toastify';
import Seo from './components/Seo';
import { useTrafficSource } from './hooks/useTrackingSource.js';
import Loading from './components/Loading';
import RequireAdmin from './components/RequireAdmin.jsx';
import StagingBanner from './components/StagingBanner';

// Admin pages load only after RequireAdmin passes, so visitors never download them.
const Admin = lazy(() => import('./pages/PageAdmin.jsx'));
const AdminReviewVenue = lazy(() => import('./pages/PageAdminReviewVenue'));

const adminOnly = (page) => (
  <RequireAdmin>
    <Suspense fallback={<Loading />}>{page}</Suspense>
  </RequireAdmin>
);

const AppContent = () => {
  useTrafficSource();

  return (
    <>
      {/*
        One <Seo/> for the whole app. It reads the current path and takes
        its title, description, canonical and robots rule from
        src/components/Seo/config.js, so no page can be missed.
        A page may render its own <Seo/> to override a single value.
      */}
      <Seo />
      <ToastContainer position="bottom-right" style={{ fontSize: '14px' }} />
      <Switch>
        {/* <Route path="/reservations/:tabs/:uid" children={<Reservations />} /> */}
        <Route path="/profile" children={<Profile />} />
        {/* <Route path="/hostvenues" children={<HostVenue />} /> */}
        <Route path="/search" children={<SearchVenues />} />
        <Route path="/favorites" children={<FavoriteVenues />} />
        <Route path="/reservations" children={<ReservedVenues />} />
        <Route path="/admin/review/:id" children={adminOnly(<AdminReviewVenue />)} />
        <Route path="/host/venues" children={<HostedVenues />} />
        <Route path="/host/reservations" children={<HostReservations />} />
        <Route path="/host/stripe" children={<HostStripeRedirect />} />
        <Route path="/confirmation" children={<Confirmation />} />
        {/* Venue-search VS1.2: the one link Braeden sends a host. */}
        <Route path="/list-your-venue/not-a-fit" children={<PageNotAFit />} />
        <Route path="/list-your-venue" children={<PageListYourVenue />} />
        {/* AEO-9: the four legal documents. One component, one data file each. */}
        <Route path="/faq" children={<Faq />} />
        {/* AEO-11a: who runs Yedding. Public, and linked from the footer. */}
        <Route path="/about" children={<About />} />
        <Route path="/how-it-works" children={<HowItWorks />} />
        <Route path="/terms" children={<Legal slug="terms" />} />
        <Route path="/privacy" children={<Legal slug="privacy" />} />
        <Route path="/host-agreement" children={<Legal slug="host-agreement" />} />
        <Route path="/guest-agreement" children={<Legal slug="guest-agreement" />} />
        {/* <Route path="/stripe/reauth" exact children={<StripeRefresh />} /> */}
        <Route path="/admin/home" exact children={adminOnly(<Admin />)} />
        <Route path="/logout" exact children={<Logout />} />
        <Route path="/" children={<Home />} />
      </Switch>
      <StagingBanner />
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
